enum PATHS {
  HOME = '/',
  LOGIN = '/login',
  SALES = '/sale',
  SALES_START = '/sale/start',
  OFFER_SETUP = '/sale/offer-setup',
  SUMMARY = '/sale/summary',
  CHECKOUT = '/sale/checkout',
  BILLING = '/sale/billing',
  LEADS = '/leads',
}

export default PATHS
